// extracted by mini-css-extract-plugin
export default {"mainDisplay":"Chat_mainDisplay__trvNI","sideDrawer__main":"Chat_sideDrawer__main__Go-gN","resizer":"Chat_resizer__i7zdz","siderDrawer__content":"Chat_siderDrawer__content__7wvXz"};